import { Controller } from "@hotwired/stimulus"

// Disables a button on click/submit until turbo stream response updates the UI
export default class extends Controller {
  static targets = ["button"]

  disable(event) {
    const button = this.hasButtonTarget
      ? this.buttonTarget
      : event.currentTarget.querySelector("button") || event.currentTarget
    if (button) {
      button.disabled = true
      button.classList.add("opacity-50", "cursor-not-allowed")
    }
  }
}
